import axios from "axios";

const prepareData = (data) => { return { store_overall: data } }

// Plural Actions
export const GET_STORE_OVERALLS = "get_store_overalls";
export const getStoreOveralls = (showHidden) => {
	let url = `/store/overalls.json`
	if (showHidden) {
		url += `?show_hidden=true`
	}
	const request = axios.get(url);
	return {
		type: GET_STORE_OVERALLS,
		payload: request
	};
};


// Singular Actions
export const CREATE_STORE_OVERALL = "create_store_overall";
export const createStoreOverall = (data) => {
	const url = `/store/overalls.json`
	const request = axios({ method: "post", url: url, data: prepareData(data) });
	return {
		type: CREATE_STORE_OVERALL,
		payload: request
	};
};

export const GET_STORE_OVERALL = "get_store_overall";
export const getStoreOverall = (id) => {
	const url = `/store/overalls/${id}.json`
	const request = axios.get(url);
	return {
		type: GET_STORE_OVERALL,
		payload: request
	};
};

export const UPDATE_STORE_OVERALL = "update_store_overall";
export const updateStoreOverall = (id, data) => {
	const url = `/store/overalls/${id}.json`
	const request = axios({ method: "patch", url: url, data: prepareData(data) });
	return {
		type: UPDATE_STORE_OVERALL,
		payload: request
	};
};

export const MOVE_STORE_OVERALLS = "move_store_overalls";
export const moveStoreOveralls = (data) => {
	const url = `/store/overalls/move.json`
	const request = axios({ method: "patch", url: url, data: prepareData(data) });
	return {
		type: MOVE_STORE_OVERALLS,
		payload: request
	};
};

export const DESTROY_STORE_OVERALL = "destroy_store_overall";
export const destroyStoreOverall = (id) => {
	const url = `/store/overalls/${id}.json`
	const request = axios({ method: "delete", url: url });
	return {
		type: DESTROY_STORE_OVERALL,
		payload: request
	};
};
